import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class CountExpirate {
    All:string = '0';
    ExpireToday:string = '0';
    CloseToExpire:string = '0';
  };





